// extracted by css-extract-rspack-plugin
export default {"SanitizedHtml":"text-cell-module__SanitizedHtml__V6_ZpYC"};